import React from 'react';
import i18next from 'i18next';
import {useTranslation} from 'react-i18next';
import {styles} from './styles';
function Index() {
    const {i18n} = useTranslation();
    const isEnglish = i18n.language === 'en';

    return (
        <div style={styles.content}>
            <div
                onClick={() => i18next.changeLanguage('en')}
                style={isEnglish ? { ...styles.option, ...styles.optionActive } : styles.option}
            >
                <img style={styles.flag} src={require('../../assets/icons/english.png')} alt="" />
                <span>EN</span>
            </div>

            <div style={styles.divider} />

            <div
                onClick={() => i18next.changeLanguage('es')}
                style={isEnglish ? styles.option : { ...styles.option, ...styles.optionActive }}
            >
                <img style={styles.flag} src={require('../../assets/icons/spanish.png')} alt="" />
                <span>ES</span>
            </div>
        </div>
    );
}

export default Index;
